<div class="me-banners--card" *ngIf="data">
    <div class="me-banners--card__icon close-icon">
        <i class="fal fa-times"></i>
    </div>
    <div class="me-banners--card__header">
        {{data.headline}}
    </div>

    <div *ngIf="data.image"
         class="me-banners--card__image align-content-center"
         [innerHTML]="data.image | storyblokImage:'stb-image'"></div>

    <div class="me-banners--card__description">
        <div class="me-banners--card__content"
             *ngIf="data?.body"
             [innerHTML]="data.body | storyblokRichtext">
        </div>
    </div>
    <div class="me-banners--card__footer">
        <div class="me-banners--card__button full-width"
             *ngIf="data.button && data.button.length"
             [innerHTML]="data.button[0] | storyblokButton">
        </div>
    </div>
</div>
